<template>
	<Dropdown v-if="user">
		<template #trigger>
			<button class="btn btn-ghost normal-case gap-0 sm:gap-2" :title="user?.name || user?.email">
				<UserAvatar :user="user" class="max-w-8 max-h-8" />
				<div class="hidden sm:block">{{ displayName }}</div>
				<ChevronDownIcon class="-mr-1 ml-2 h-3 w-3" />
			</button>
		</template>
		<template #content>
			<DropdownMenu class="w-72 overflow-hidden">
				<DropdownMenuItem>
					<a href="/preferences">{{ $t("Preferences") }}</a>
				</DropdownMenuItem>

				<DropdownMenuItem v-if="user?.isSuperAdmin()">
					<a @click.prevent="impersonateAnyone" class="">{{ $t("Impersonate") }}</a>
				</DropdownMenuItem>

				<DropdownMenuItem>
					<a @click.prevent="logout">{{ $t("Log out") }}</a>
				</DropdownMenuItem>
			</DropdownMenu>
		</template>
	</Dropdown>
</template>

<script lang="ts">
import Dropdown from "../ui/Dropdown.vue";
import DropdownMenu from "../ui/DropdownMenu.vue";
import DropdownMenuItem from "../ui/DropdownMenuItem.vue";
import { ChevronDownIcon, CheckIcon } from "@heroicons/vue/24/outline";
import { User } from "@/models/User.model";
import { auth } from "@/auth";
import { useUsersStore } from "@/stores/Users.store";
import { mapStores } from "pinia";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
	name: "TheUserMenu",

	components: {
		Dropdown,
		DropdownMenu,
		DropdownMenuItem,
		CheckIcon,
		ChevronDownIcon,
		UserAvatar,
	},

	props: {
		user: {
			type: User,
			required: true,
		},
	},

	computed: {
		...mapStores(useUsersStore),
		// displayName: prefer the user's name; if missing, show a truncated email
		displayName(): string {
			// `this.user` comes from props
			const u = this.user.getNameIdentifier();
			if (!u) return ""; //if no name or email, return empty string
			return this.truncate(u, 24);
		},
	},

	methods: {
		// small helper to truncate long strings (keeps start and end parts)
		truncate(value: string, max = 24) {
			if (!value) return "";
			if (value.length <= max) return value;
			// keep start and end with an ellipsis in the middle
			const part = Math.floor((max - 1) / 2);
			return value.slice(0, part) + "…" + value.slice(value.length - part);
		},
		logout() {
			auth.logout();
		},

		async impersonateAnyone() {
			const email = prompt("Enter the email of the user you want to impersonate");
			if (!email) {
				return;
			}

			const user = await this.usersStore.loadFromEmail(email);
			if (!user) {
				alert("User not found");
				return;
			}

			await this.usersStore.impersonate(user.id);
		},
	},
};
</script>
